import { AwsConfig as AwsConstants } from './Constants';
import BaseService from './Base';


export default class IOTService extends BaseService {
  constructor() {
    super(AwsConstants.API_CONFIG, 'iot');
  }

  async connect(): Promise<string> {
    const res = await super.post<string>('');
    return res;
  }
  async disconnect(): Promise<void> {
    const res = await super.delete<void>('');
    return res;
  }
}